import Vue from 'vue'
import App from './App.vue'
import * as VueGoogleMaps from "vue2-google-maps"
import router from './router'
import axios from 'axios'
import VueSuggestion from 'vue-suggestion'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCKYTICtbqBnq2XB7_2GvXyFWSxS6VTFY0",
    libraries: "places"
  }
});
Vue.use({
  install (Vue) {
    Vue.prototype.$axios = axios
  },
})
Vue.use(VueSuggestion)

export const bus = new Vue()

new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app')
